import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, LifeBuoy, PiggyBank, Sunrise, FolderKanban, Calculator } from "lucide-react";
import { Container, PageFade, Reveal } from "../components/site/Motion";
import { PageHeader, TopicGrid } from "../components/site/Sections";
import { ConsultationSection } from "../components/site/ConsultationSection";

const TOPICS = [
  { icon: ShieldCheck, t: "Protection du revenu en cas d'invalidité", d: "Votre capacité à travailler est votre principal actif : il est utile de comprendre comment la protéger." },
  { icon: LifeBuoy, t: "Constitution d'un fonds d'urgence", d: "Une réserve pour traverser une période creuse ou une dépense imprévue." },
  { icon: PiggyBank, t: "Épargne et placements", d: "Mettre de côté régulièrement, selon vos moyens et vos objectifs." },
  { icon: Sunrise, t: "Planification de la retraite", d: "Sans régime d'employeur, la retraite se prépare en amont." },
  { icon: FolderKanban, t: "Organisation financière", d: "Séparer, suivre et structurer vos finances professionnelles et personnelles." },
  { icon: Calculator, t: "Stratégies fiscales", d: "Des pistes à explorer avec les professionnels appropriés (comptable, fiscaliste)." },
];

export default function NonIncorpores() {
  return (
    <PageFade>
      <PageHeader eyebrow="Plans pour les travailleurs non incorporés" title="Votre entreprise, c'est vous." accent="Protégez ce que vous bâtissez." image="/img/entrepreneur2.jpg">
        <p className="max-w-xl text-lg text-[#242020]/80">Travailleurs autonomes, consultants et professionnels indépendants : vos revenus dépendent directement de vous. Voici les enjeux à considérer.</p>
        <Link to="/secteurs" className="btn-primary" data-testid="non-inc-cta">DÉCOUVRIR MON FORFAIT <ArrowRight className="h-4 w-4" /></Link>
      </PageHeader>
      <Container className="py-16 lg:py-24">
        <Reveal><h2 className="mb-10 text-3xl sm:text-4xl">Les enjeux à considérer</h2></Reveal>
        <TopicGrid items={TOPICS} testid="non-inc-topics" />
        <Reveal className="mt-14 text-center">
          <Link to="/secteurs" className="btn-primary" data-testid="non-inc-cta-bottom">DÉCOUVRIR MON FORFAIT <ArrowRight className="h-4 w-4" /></Link>
        </Reveal>
      </Container>
      <ConsultationSection />
    </PageFade>
  );
}
